export default "__VITE_ASSET__Dx0ls8rt__"